import script from "./SwitchButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SwitchButton.vue?vue&type=script&setup=true&lang=js"

import "./SwitchButton.vue?vue&type=style&index=0&id=6248f202&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6248f202"]])

export default __exports__